module.exports = __webpack_public_path__ + "img/Skirt-Front-B1-Db-Fc-Ga-Hc-Ia.34419fb5.png";